import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionOptionsService } from '../../../../core/services/session-option.service';
import { PlaybackModeMenuComponent } from '../playback-mode-menu/playback-mode-menu.component';

@Component({
  selector: 'app-session-options-dialog',
  standalone: true,
  imports: [],
  templateUrl: './session-options-dialog.component.html',
  styleUrls: ['./session-options-dialog.component.css'],
})
export class SessionOptionsDialogComponent {
  monitorModeName: string = 'Monitor Mode';
  liveModeName: string = 'Live Mode';
  playbackModeName: string = 'Playback Mode';

  constructor(
    public activeModal: NgbActiveModal,
    private sessionOptionsService: SessionOptionsService,
    private modalService: NgbModal
  ) {}

  closeModal() {
    this.activeModal.dismiss();
  }
  selectMode(mode: string) {
    if (mode === this.playbackModeName || mode === this.liveModeName) {
      this.openPlaybackLiveModeMenu(mode);
    } else {
       this.sessionOptionsService.setMode(mode);
       this.sessionOptionsService.goToMonitorMode();
      this.sessionOptionsService.setSessionData({
        mode: mode,
      });
      this.activeModal.close(mode);
    }
  }

  openPlaybackLiveModeMenu(mode?: string) {
    const modalRef = this.modalService.open(PlaybackModeMenuComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    if (mode === this.liveModeName) {
      modalRef.componentInstance.showLiveModeOptions = true;
      modalRef.componentInstance.showPlaybackModeOptions = false;
    } else if (mode === this.playbackModeName) {
      modalRef.componentInstance.showLiveModeOptions = false;
      modalRef.componentInstance.showPlaybackModeOptions = true;
    }
    modalRef.result.then(
      (result) => {
        if(result)
        if (result === 'Playback Mode') {
          this.activeModal.close('Playback Mode');
        }else if(result === 'Live Mode') {
          this.activeModal.close('Live Mode');
        }
      },
      () => {}
    );
  }
}
